'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import useFetchFintechOutagesStatus from '../hooks/useFetchFintechOutagesStatus.hook';
import FintechOutageBanner from './FintechOutageBanner';
import noop from '../utils/noop.util';

const FintechOutageBannerWithFetch = ({
  actionContext,
  hubId = null,
  onError = noop
}) => {
  const outagesStatus = useFetchFintechOutagesStatus(hubId, onError);
  return /*#__PURE__*/_jsx(FintechOutageBanner, {
    availabilityStatus: outagesStatus,
    actionContext: actionContext
  });
};

export default FintechOutageBannerWithFetch;